import { getFocalPointStyles,parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { StyledTypography } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import parse from "html-react-parser";
import { css } from "styled-components";
 
const enum fields {      
    title = "title",
    backgroundColor = "backgroundColor",
    titleTextColor = "titletextcolor",
    subText = "subText",
    subTextColor = "subTextColor",  
    ctaText = "ctaText",    
    buttonVariant = "variant",
    link = "link", 
    isVisible = "isVisible",  
}
 
interface Props extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.backgroundColor]: string;
        [fields.titleTextColor]:string;
        [fields.subText]:string;
        [fields.subTextColor]:string;
        [fields.ctaText]:string;
        [fields.buttonVariant]: "primary" | "secondary" | "tertiary";           
        [fields.link]: LinkFieldValue;
    };
}

export interface TextSubtextAndButtonStyles {
    textSubtextAndButton?: InjectableCss;
    widgetButton?: ButtonPresentationProps;
}
 
const TextSubtextAndButton: React.FC<Props> = ({ fields }) => {
    const { url } = useGetLink(fields.link);
    const onClick = () => {
        if (!url) {
            return;
        }
        window.location.href = url;        
    };
    const topBarStyles: TextSubtextAndButtonStyles = {
        textSubtextAndButton: {
                css:css`
                background: ${fields.backgroundColor};
                text-align: center;
                padding: 42px 20px 40px;                  
           
                div{
                    max-width: 895px;
                    padding-left: 20px;
                    padding-right: 20px;
                    width: 100%;
                    
                    @media (min-width:768px) {
                        margin: 0 auto;                        
                    }
                } 

                h2{
                    color:${fields.titletextcolor};
                    font-family: ITC Avant Garde Gothic,Helvetica Neue,Arial,Noto Sans,sans-serif;
                    font-size: 32px;
                    font-weight: 500;
                    margin: 0 0 18px;
                    text-align: center;
                    line-height: 1.26; 
                    @media (min-width: 768px) { margin: 0 0 22px;}
                }  
                button{
                    border-radius: 10px
                }
                p{
                    margin: 0 0 23px;
                    font-family: ITC Avant Garde Gothic,Helvetica Neue,Arial,Noto Sans,sans-serif;
                    font-size: 18px;
                    font-weight: 500;
                    text-align: center;
                    color:${fields.subTextColor}
                }

                
                @media (min-width: 768px) 
                { 
                    line-height: 1.4;
                    padding: 83px 0 92px;
                }  
                `,
        }
    };
        
    return (   
          <>  
        <StyledTypography {...topBarStyles.textSubtextAndButton} as="section" className="as-content-section as-text-center as-bg-light-grey">
        <div className="as-container">
                <h2>{fields.title}</h2> 
                {fields.subText && parse(fields.subText, parserOptions)}
                   {fields.ctaText !== "" && fields.link.value !== "" && (                
                <Button {...topBarStyles.widgetButton} variant={fields.variant} onClick={onClick}>
                                {fields.ctaText}
                            </Button>
            )}
            </div>
        </StyledTypography>
        </>     
    );
};
const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};
const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.title,
            displayName: "Title text",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            isRequired: true,
            tooltip: "Enter the text",
        },
        {
            name: fields.backgroundColor,
            displayName: "Background Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isRequired: true,
            tooltip: "Select the Background Color",
        },
        {
            name: fields.titleTextColor,
            displayName: "Title Text Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isRequired: true,
            tooltip: "Select Title Text Color",
        },
        {
            name: fields.subTextColor,
            displayName: "Sub Text Color",
            fieldType: "General",
            editorTemplate: "ColorPickerField",
            defaultValue: "",
            isRequired: true,
            tooltip: "Select Sub Title Text Color",
        },
        {
            name: fields.ctaText,
            displayName: "CTA text",
            fieldType: "General",
            editorTemplate: "TextField",
            defaultValue: "",
            tooltip: "Enter the text",
        },
        {
            name: fields.buttonVariant,
            displayName: "Button Variant",
            editorTemplate: "DropDownField",
            options: [
                { displayName: "Primary", value: "primary" },
                { displayName: "Secondary", value: "secondary" },
                { displayName: "Tertiary", value: "tertiary" },
            ],
            hideEmptyOption: true,
            defaultValue: "primary",
            fieldType: "Contextual",
            tab: basicTab,
        },

        {
            name: fields.subText,
            displayName: "Sub text", 
            fieldType: "Contextual",           
            editorTemplate: "RichTextField",            
            defaultValue: "",
          
        },

        {
            name: fields.link,
            fieldType: "General",
            displayName: "Destination URL",
            editorTemplate: "LinkField",
            defaultValue: { 
                value: "" ,
                 type: "Page"
                },
            tooltip: "select the link url",
        },
    ],
};
 
const widgetModule: WidgetModule = {
    component: TextSubtextAndButton,
    definition,
};
 
export default widgetModule;